// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"0b6e18e56ca8cf40d7a1","293":"0505dc04fa6e7722e62f","518":"ba89f8eeeade3cbbc8b2","779":"4836c9fd7ebaafa983a6"}[chunkId] + ".js";
};